import { Markdown, MarkdownParagraphs } from "../components/Markdown";
import {
  channels,
  channelsLeadIn,
  committees,
  committeeTasksLeadIn,
  getInvolved,
  getInvolvedHeading,
  joinCtaLabel,
  joinCtaUrl,
  joinLede,
  joinTitle,
  links,
  meetingAddress,
  meetingVenue,
  meetingWhen,
  meetingWhenLabel,
  meetingWhereLabel,
  meetings,
  meetingsHeading,
  subcommitteesHeading,
  subcommitteesIntro,
} from "../content";
import pin from "../images/pin-point.png";
import "../styles/page.css";
import "../styles/subcommittees.css";

function Join() {
  return (
    <main id="main-content" tabIndex={-1} className="page">
      <header className="page__masthead">
        <div className="page__masthead-inner">
          <h1 className="page__title">{joinTitle}</h1>
          <p className="page__lede">{joinLede}</p>
          <div className="page__masthead-actions">
            <a
              className="page__cta"
              href={joinCtaUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${joinCtaLabel} (opens in new tab)`}
            >
              {joinCtaLabel}
            </a>
          </div>
        </div>
      </header>

      {/* Dark panel between the masthead and the cream subcommittee cards, so
          the page alternates rather than running as one long light block. */}
      <section className="page__panel">
        <div className="page__panel-inner">
          <div>
            <h2 className="page__heading">{getInvolvedHeading}</h2>
            <div className="page__prose">
              <MarkdownParagraphs items={getInvolved} />
            </div>

            <p className="channels__leadin">{channelsLeadIn}</p>
            <ul className="channels">
              {channels.map((channel) => (
                <li key={channel.id}>
                  <a
                    className="channel"
                    href={channel.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${channel.label} (opens in new tab)`}
                  >
                    <img className="channel__icon" src={channel.icon} alt="" aria-hidden="true" />
                    <span>{channel.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="page__heading">{meetingsHeading}</h2>

            <dl className="meeting">
              <div className="meeting__row">
                <dt className="meeting__label">{meetingWhenLabel}</dt>
                <dd className="meeting__value">{meetingWhen}</dd>
              </div>
              <div className="meeting__row">
                <dt className="meeting__label">{meetingWhereLabel}</dt>
                <dd className="meeting__value">
                  {meetingVenue}
                  <a
                    className="meeting__directions"
                    href={links.directions}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Directions to ${meetingAddress} (opens in new tab)`}
                  >
                    <img className="meeting__pin" src={pin} alt="" aria-hidden="true" />
                    {meetingAddress}
                  </a>
                </dd>
              </div>
            </dl>

            <div className="page__prose">
              <MarkdownParagraphs items={meetings} />
            </div>
          </div>
        </div>
      </section>

      <section id="subcommittees" className="subs subs--dark">
        <div className="subs__intro">
          <h2 className="subs__title">{subcommitteesHeading}</h2>
          <p className="subs__subhead">{subcommitteesIntro}</p>
        </div>

        <ul className="subs__grid">
          {committees.map((committee) => (
            <li key={committee.id} className="subs__card">
              {/* The icon art spells the subcommittee's name, so it is the heading. */}
              <h3 className="subs__name">
                <img className="subs__icon" src={committee.icon} alt={committee.name} />
              </h3>
              <p className="subs__blurb">
                <Markdown>{committee.intro}</Markdown>
              </p>
              <p className="subs__leadin">{committeeTasksLeadIn}</p>
              <ul className="subs__tasks">
                {committee.items.map((item) => (
                  <li key={item}>
                    <Markdown>{item}</Markdown>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
}

export default Join;
